/**
 * Paths that must not be indexed (thank-you flows, search, HTML sitemap,
 * staging/test pages, form endpoints).
 * Keep in sync with sitemap exclusions.
 */
const EXACT_NOINDEX_PATHS = new Set([
  "/booking-thank-you",
  "/enquiry-thank-you",
  "/payment-success",
  "/search",
  "/sitemap",
  "/error",
  "/sandbox",
  "/quizzes/test-quiz",
  "/booking-form",
  "/enquiry",
]);

export function normalizeAppPath(path: string): string {
  const withoutQuery = path.split("?")[0] ?? path;
  const trimmed = withoutQuery.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
}

export function shouldNoIndexPath(path: string): boolean {
  const p = normalizeAppPath(path);
  if (EXACT_NOINDEX_PATHS.has(p)) return true;
  if (p.endsWith("-enquiry-submitted")) return true;
  return false;
}
